<template>
  <div>
    <v-row class="text--primary">
      <v-col cols="12" sm="6">
        <px-card-endereco-cpf-cnpj :local="contratacao.coleta"
                                   :municipio="contratacao.municipioColeta"
                                   :is-pagador="isPagamentoColeta"/>
      </v-col>
      <v-col cols="12" sm="6">
        <px-card-endereco-cpf-cnpj label="Local de entrega"
                                   :local="contratacao.entrega"
                                   :municipio="contratacao.municipioEntrega"
                                   :is-pagador="isPagamentoEntrega"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { LocalPagamentoFrete } from 'px-business-components';

export default {
  props: {
    contratacao: Object,
  },
  computed: {
    isPagamentoColeta() {
      return LocalPagamentoFrete.keys.COLETA.key === this.contratacao.localPagamento;
    },
    isPagamentoEntrega() {
      return LocalPagamentoFrete.keys.ENTREGA.key === this.contratacao.localPagamento;
    },
  },
};
</script>
